module.exports = JSON.parse("{\"paths\":[],\"buildDate\":\"2026-10-21T11:34:54.610Z\"}")